<template>
  <div> 
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="6" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="light">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">Expense</h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ getExpInvList.length }} Entries</small>
            </h5>
          </b-col>
          <b-col md="4">
            <b-button
              class="pull-right ml-1 mt-1"
              :variant="
                Filter.dateRange.startDate || Filter.dateRange.endDate
                  ? 'outline-danger'
                  : 'outline-primary'
              "
              :class="' ml-4' + visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4"
              @click="visible = !visible"
              style="font-size: 0.675rem"
              >{{
                Filter.dateRange.startDate || Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button
            >
            <b-button
              class="pull-right ml-1 mt-1"
              v-if="getExpInvList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="exportInvExpSaleReport('getExpInvList', 'Export As Excel')"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >
              {{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export As Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>
          </b-col>

          <b-col cols="6">
            <div>
              <b-pagination
                limit="5"
                :total-rows="getExpInvList.length"
                :per-page="pagination.perPage"
                v-model="pagination.currentPage"
                class="my-0 pull-right"
              />
            </div>
          </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker
                    :always-show-calendars="showCal"
                    v-model="Filter.dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    :disabled="Filter.DFlag ? true : false"
                    @update="getInvExpSale('Normal', '0', '0', '1', '1')"
                  ></date-range-picker>
                </b-col>
                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    placeholder="Common Filter"
                    id="commonFilter"
                    name="commonFilter"
                    v-model="Filter.commonFilter"
                    @input="getInvExpSale('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Invoice Filter</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    placeholder="Invoice Filter"
                    id="invFilter"
                    name="invFilter"
                    v-model="Filter.invFilter"
                    @input="getInvExpSale('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Job No Filter</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    placeholder="Job No Filter"
                    id="jobFilter"
                    name="jobFilter"
                    v-model="Filter.jobFilter"
                    @input="getInvExpSale('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>

                <b-col md="12" class="mt-2">
                  <b-button
                    size="sm"
                    style="margin-left: auto"
                    class="ml-1 pull-right"
                    @click="clearFilter"
                    variant="outline-danger"
                    >Reset</b-button
                  >
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">
              <b-table
                show-empty
                stacked="md"
                responsive
                :fields="getExpInvFields"
                :items="getExpInvList"
                class="table-background position-relative"
                :per-page="pagination.perPage"
                :current-page="pagination.currentPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
              >
                <template slot="SN" slot-scope="row0">
                  <span>{{
                    row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                  }}</span>
                </template>
                <template slot="JOBNO" slot-scope="row1">
                  <span>JOB NO : {{ row1.item.JOBNO }}</span
                  ><br />
                  <span>JOB Date : {{ row1.item.JOBDate }}</span
                  ><br />
                  <span>JOB Type : {{ row1.item.JOBTYPE }}</span
                  ><br />
                  <span>Booking No : {{ row1.item.validBookingNo }}</span
                  ><br />
                  <span>Client : {{ row1.item.clientName }}</span
                  ><br />
                  <span>Sline : {{ row1.item.shippingLine }}</span><br />
                  <span>Raised From : {{ row1.item.RaisedFrom }}</span><br />
                  <span>Raised By : {{ row1.item.RaisedBy }}</span>
                  <Assignment-Summary
                    v-if="$sessionsStorage.get('is_Mobile') != 'port' && row1.item.inv_module_id"
                    :title="'Shipment Summary Tracking - '"
                    :assign_date="row1.item.JOBDate"
                    :assign_job_type="row1.item.JOBTYPE"
                    :assign_raised_from="''"
                    :assign_raised_by="''"
                    :fk_all_module_id="row1.item.inv_module_id"
                    :jb_series="row1.item.JOBNO"
                    :fk_client_id="''"
                    :fk_pod_id="''"
                  />
                  <InvExpSummary
                    v-if="row1.item.inv_module_id"
                    :PMC_title="'Inv Exp Summary Job No - ' + row1.item.JOBNO"
                    :PMC_JOBID="row1.item.inv_module_id"
                    :PMC_JOBNO="row1.item.JOBNO"
                    :PMC_JOBDATE="row1.item.JOBDate"
                    :PMC_JOBTYPE="row1.item.JOBTYPE"
                    :PMC_AgentType="''"
                    :PMC_Client="row1.item.clientName"
                    :PMC_Sline="row1.item.shippingLine"
                  />
                  <JobWisePaymentsDetails
                  v-if="row1.item.inv_module_id"
                  :allModuleId="Number(row1.item.inv_module_id)"
                  :JobNo="row1.item.JOBNO"
                  />
                  <ContainerSummary
                    v-if="row1.item.inv_module_id"
                    :PMC_title="'Container Summary Job No - ' + row1.item.JOBNO"
                    :PMC_JOBID="row1.item.inv_module_id"
                    :PMC_JOBNO="row1.item.JOBNO"
                    :PMC_JOBDATE="row1.item.JOBDate"
                    :PMC_JOBTYPE="row1.item.JOBTYPE"
                    :PMC_AgentType="''"
                    :PMC_Client="row1.item.clientName"
                    :PMC_Sline="row1.item.shippingLine"
                  />
                  <RejectInvTallyBillSummary
                    v-if="row1.item.inv_module_id"
                    :PMC_title="
                      'Invoice Rejection Log Summary Job No - ' +
                      row1.item.JOBNO
                    "
                    :PMC_JOBID="row1.item.inv_module_id"
                    :PMC_JOBNO="row1.item.JOBNO"
                    :PMC_JOBDATE="row1.item.JOBDate"
                    :PMC_JOBTYPE="row1.item.JOBTYPE"
                    :PMC_Client="row1.item.clientName"
                    :PMC_Sline="row1.item.shippingLine"
                  />
                </template>
                <template slot="JOBDate" slot-scope="row2">
                  <span>FF : {{ row2.item.FFInvStatus }}</span><br />
                  <span>CC : {{ row2.item.CCInvStatus }}</span><br />
                  <span>TPT : {{ row2.item.TPTInvStatus }}</span><br />
                  <span>CR : {{ row2.item.OSCRSERIES }}</span><br />
                  <span>DR : {{ row2.item.OSDRSERIES }}</span><br />
                  <span>Tally INV : {{ row2.item.tallyExistInvoice }}</span><br />
                  <span>Inv NO : {{ row2.item.inv_no }}</span
                  ><br />
                  <span>Inv Date : {{ row2.item.inv_date }}</span
                  ><br />
                  <span>Inv Type : {{ row2.item.inv_type }}</span
                  ><br />
                  <span>Type : {{ row2.item.inv_exp_type }}</span>
                </template>
                <template slot="inv_item" slot-scope="row3">
                  <span>{{ row3.item.inv_item }}</span>
                </template>
                <template slot="inv_amt" slot-scope="row4">
                  <span>{{ row4.item.inv_amt }}</span>
                </template>
                <template slot="item_created_date" slot-scope="row5">
                  <span>Created Item Date : {{ row5.item.item_created_date }}</span
                  ><br />
                  <span>Updated Item Date : {{ row5.item.item_updated_date }}</span>
                </template>
              </b-table>
            </div>
            <div>
              <b-pagination
                limit="5"
                :total-rows="getExpInvList.length"
                :per-page="pagination.perPage"
                v-model="pagination.currentPage"
                class="my-0 pull-right"
              />
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import UlipService from "../../services/UlipService.js";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { read, utils, writeFile } from "xlsx";
import AssignmentSummary from "../common/assignmentSummary.vue";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";
export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);

    if (globalPermissionStatus("Dashboard_Access") || globalPermissionStatus("ULIP")) {
      this.$store.dispatch("setCurrentRoute", "/sale/every-day-sale-dash");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.getInvExpSale("Normal", "0", "0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  mounted() {},
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},
  data() {
    return {
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getExpInvList: [],
      totalData: 0,
      getExpInvFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "JOBNO",
          mainkey: "JOBNO",
          label: "JOB Details",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "JOBDate",
          mainkey: "JOBDate",
          label: "Inv Details",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "inv_item",
          mainkey: "inv_item",
          label: "Particulars",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "inv_amt",
          mainkey: "inv_amt",
          label: "AMT",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "item_created_date",
          mainkey: "item_created_date",
          label: "Particulars Date",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],
      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      Filter: {
        jobFilter: "",
        invFilter: "",
        commonFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
    AssignmentSummary,
    InvExpSummary,
    ContainerSummary,
    JobWisePaymentsDetails,
    RejectInvTallyBillSummary,
  },
  computed: {},
  watch: {},
  methods: {
    clearFilter() {
      this.Filter = {
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getInvExpSale("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },
    getParseDate(dateString) {
      if(dateString){
      // Split the date string into day, month, and year components
      const [day, month, year] = dateString.split("-").map(Number);

      // Create a new Date object with the parsed components
      return new Date(year, month - 1, day); // Month is zero-indexed in JavaScript Date
      }else{
        return;
      }
    },
    exportInvExpSaleReport() {
      if (this.getExpInvList.length > 0) {
        this.ExcelBtnName = "Downloading....";
        let newSheetdata = [];
        this.getExpInvList.map((obj, index) => {
          let SN = parseInt(index) + parseInt(1);

          const newData = {
            SN: SN,
            inv_exp_type: obj.inv_exp_type,
            JOBNO: obj.JOBNO,
            JOBDate: this.getParseDate(obj.JOBDate),
            MonthName: obj.MonthName,
            JOBTYPE: obj.JOBTYPE,
            BookingNo: obj.validBookingNo,
            SplitMergeStatus:obj.isSplitedOrMerged,
            clientName: obj.clientName,
            shippingLine: obj.shippingLine,
            RaisedFrom: obj.RaisedFrom,
            RaisedBy: obj.RaisedBy,
            FFInvStatus: obj.FFInvStatus,
            CCInvStatus: obj.CCInvStatus,
            TPTInvStatus: obj.TPTInvStatus,
            MiscInvStatus: obj.MiscInvStatus,
            BillingStatus: obj.BillingStatus,
            ManifestStatus: obj.ManifestStatus,
            OverseasBillingStatus: obj.OverseasBillingStatus,
            OSDRSERIES: obj.OSDRSERIES,
            OSCRSERIES: obj.OSCRSERIES,
            tallyExistInvoice: obj.tallyExistInvoice,
            inv_no: obj.inv_no,
            inv_date: this.getParseDate(obj.inv_date),
            inv_created_date: obj.inv_created_date,
            inv_updated_date: obj.inv_updated_date,
            inv_type: obj.inv_type,
            inv_item: obj.inv_item,
            inv_amt: obj.inv_amt,
            inv_without_currency_amt: obj.inv_without_currency_amt,
            item_created_date: this.getParseDate(obj.item_created_date),
            item_updated_date: (obj.item_updated_date),
          };
          newSheetdata.push(newData);
        });
        let fileName = "Ocean_Freight_Particulars_Expense_Master_Report_" + ".xlsx";
        const headings = [
          [
            "SN",
            "Type",
            "Job No",
            "Job Date",
            "Job Month Name",
            "Job Type",
             "Booking No",
             "Split/Merge Status",
            "Client",
            "Sline",
            "Branch",
            "Raised BY",
            "FF Status",
            "CC Status",
            "TPT Status",
            "MISC Status",
            "Billing Status",
            "Manifest Status",
            "Overseas Billing Status",
            "Credit Note",
            "Debit Note",
            "Tally Inv No",
            "Inv No",
            "Inv Date",
            "Inv Created",
            "Inv Updated",
            "Inv Type",
            "Inv Item",
            "Item AMT",
            "Item Without Currency AMT",
            "Item Created",
            "Item Updated",
          ],
        ];
        const wb = utils.book_new();
        const ws = utils.json_to_sheet([]);
        utils.sheet_add_aoa(ws, headings);
        utils.sheet_add_json(ws, newSheetdata, { origin: "A2", skipHeader: true });
        utils.book_append_sheet(wb, ws, "Report");
        writeFile(wb, fileName);
        this.ExcelBtnName = "Export As Excel";
      }
    },
    getInvExpSale(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.getExpInvList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getOEExpenseList",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.pagination.perPage,
        Filter: this.Filter,
      };

      UlipService.getAllUlipList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data) {
            if (type == "Excell") {
              if (data.getExpInvList.length > 0) {
                this.totalData = data.totalData;
                this.getExpInvList = data.getExpInvList;
              }
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.getExpInvList.length > 0) {
                this.totalData = data.totalData;
                this.getExpInvList = data.getExpInvList;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getExpInvList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() {},
    goBack() {
      window.history.go(-1);
    },
    filterClear() {
      this.Filter = {
        jobFilter: "",
        invFilter: "",
        commonFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getInvExpSale("Normal", "0", "0", "1", "1");
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getInvExpSale("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getInvExpSale("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getInvExpSale("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      // this.getInvExpSale("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// OceanFreightExpenseCard.vue?458d31d3